<template>
  <div class="givewaway-wrapper relative" id="login">
    <div class="container">
      <div class="row">
        <div class="col-md-12 wrapper-header">
          <div class="form-branding float-left">
            <a href="/">
              <img src="../../assets/img/apostle_logo.png" class="width-100 relative">
            </a>
          </div>

          <Button
            class="float-right small-none"
            variant="neutral"
            v-on:click.native="navigateToPremium"
          >{{ $t("button.premium") }}</Button>
          <Button
            class="float-right mr-2"
            variant="default"
            v-on:click.native="navigateToLogin"
          >{{ $t("button.login") }}</Button>
          <Button
            class="small-only"
            variant="neutral"
            v-on:click.native="navigateToPremium"
          >{{ $t("button.premium_small") }}</Button>
        </div>
      </div>
      <div class="row form-row">
        <div class="col-md-12">
          <Card contentSpacing="none" class="main-card">
            <div class="row">
              <div class="col-lg-4 col-md-5">
                <div class="giveway-side break-after" id="composer-wrap">
                  <Card class="composer-card" style="overflow-y: auto;">
                    <div
                      v-if="isSent"
                      class="message-sent text-center"
                      style="text-align: justify; text-justify: inter-word;"
                    >
                      <h2>{{ $t("form.text.done.title") }}</h2>
                      {{ $t("form.text.done.text.line_one") }}
                      <br>
                      <br>
                      {{ $t("form.text.done.text.line_two") }}
                      <br>
                      <br>
                      {{ $t("form.text.done.text.line_three") }}
                      <br>
                      <br>
                      <a
                        href="https://apostleconnect.com/platform/"
                        class="blue-link"
                      >{{ $t("form.text.done.link") }}</a>
                    </div>
                    <form v-if="!isSent">
                      <div class="language-selection">
                        <country-flag
                          v-bind:title="$t('langhint.nl')"
                          v-on:click.native="setLanguage('nl')"
                          country="nl"
                          v-bind:class="{ active: this.$i18n.locale === 'nl' }"
                        />
                        <country-flag
                          v-bind:title="$t('langhint.en')"
                          v-on:click.native="setLanguage('en')"
                          country="gb"
                          v-bind:class="{ active: this.$i18n.locale === 'en' }"
                        />
                      </div>
                      <div v-if="!hasMedia">
                        <Input
                          type="image"
                          width="expand"
                          v-model="formFields.upload.value"
                          v-on:input="validateInput('upload',formFields.upload)"
                        />
                        <div v-if="isUploading">
                          <progress max="100" :value.prop="uploadPercentage"></progress>
                        </div>
                      </div>
                      <img v-bind:src="mediaUrl" v-if="hasMedia" class="uploadedImage">
                      <div class="errortext-wrap"></div>
                      <Input
                        type="textarea"
                        v-bind:label="$t('form.post.label')"
                        v-on:input="validateInput('content',formFields.content)"
                        v-bind:placeholder="$t('form.post.placeholder')"
                        v-model="formFields.content.value"
                        v-bind:class="{'is-invalid': !formFields.content.valid}"
                      />
                      <div class="errortext-wrap">{{formFields.content.errortext}}</div>
                      <Input
                        type="tags"
                        v-bind:placeholder="$t('form.receivers.placeholder')"
                        v-bind:label="$t('form.receivers.label')"
                        v-on:input="validateInput('emails',formFields.emails)"
                        v-model="formFields.emails.value"
                        v-bind:class="{'is-invalid': !formFields.emails.valid}"
                      />
                      <div class="errortext-wrap">{{formFields.emails.errortext}}</div>
                      <Input
                        v-bind:label="$t('form.name.label')"
                        width="expand"
                        v-model="formFields.name.value"
                        v-on:input="validateInput('name', formFields.name)"
                        v-bind:placeholder="$t('form.name.placeholder')"
                        v-bind:class="{'is-invalid': !formFields.name.valid}"
                      />
                      <div class="errortext-wrap">{{formFields.name.errortext}}</div>
                      <Input
                        v-bind:label="$t('form.email.label')"
                        width="expand"
                        v-model="formFields.email.value"
                        v-on:input="validateInput('email',formFields.email)"
                        v-bind:placeholder="$t('form.email.placeholder')"
                        v-bind:class="{'is-invalid': !formFields.email.valid}"
                      />
                      <div class="errortext-wrap">{{formFields.email.errortext}}</div>
                      <div class="form-row text-center">
                        {{ $t("form.text.more") }}
                        <a
                          href="https://apostleconnect.com/platform/"
                          class="blue-link"
                          target="_blank"
                        >{{ $t("form.text.link") }}</a>
                      </div>
                      <div v-if="!isProcessing">
                        <Button
                          class="width-100"
                          v-on:click.native="schedule"
                          v-if="formFields.emails.value.length > 0 && formValid"
                        >{{ $t("button.schedule") }}</Button>
                        <Button
                          class="width-100"
                          v-on:click.native="schedule"
                          v-if="formFields.emails.value.length <= 0 || formFields.emails.value.length >= 11 || !formValid"
                          disabled
                        >{{ $t("button.schedule") }}</Button>
                      </div>
                      <div v-if="isProcessing">
                        <Button disabled class="width-100">{{ $t("button.scheduling") }}</Button>
                      </div>
                    </form>
                  </Card>
                </div>
              </div>
              <div class="col-lg-8 col-md-7 giveway-illustration d-none d-md-block">
                <div class="row">
                  <div class="col-md-12">
                    <PageTitle/>
                  </div>
                </div>
                <div class="width-100 relative">
                  <masonry :cols="{default: 3, 1150: 2, 1000: 1}" :gutter="15">
                    <SocialCard
                      variant="input"
                      v-for="(item, index) in wall"
                      :key="index"
                      :avatar="item.enclosure[0]._attributes.url"
                      :type="item.enclosure[1]._attributes.type"
                      :media="item.enclosure[1]._attributes.url"
                      :name="item.title._text"
                      :date="item.pubDate._text"
                      :platform="item.category._text"
                      :text="item.description._cdata"
                    >
                    </SocialCard>

                    <div
                      class="skeleton"
                      content-spacing="none"
                      v-for="index in dummies"
                      :key="index"
                    >
                      <div class="skeleton--image">
                        <Avatar size="sm"></Avatar>
                        <Avatar size="sm" class="platform"></Avatar>
                        <svgicon name="image" color="#ccc"></svgicon>
                      </div>
                      <div class="skeleton--text">
                        <span class="short"></span>
                        <span class="medium"></span>
                        <span class="long"></span>
                        <br>
                        <span class="long"></span>
                        <span class="medium"></span>
                        <br>
                        <span class="medium"></span>
                        <span class="short"></span>
                        <span class="medium"></span>
                      </div>
                    </div>
                  </masonry>
                  <div v-observe-visibility="visibilityChanged"></div>
                </div>
              </div>
            </div>
          </Card>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import axios from "axios";
import convert from "xml-js";
import VueMasonry from "vue-masonry-css";
import Card from "../../components/Card/Card";
import Input from "../../components/Input/Input";
import Button from "../../components/Button/Button";
import Avatar from "../../components/Avatar/Avatar";
import PageTitle from "../../components/Pagetitle/Pagetitle";
import SocialCard from "../../components/SocialCard/SocialCard";

Vue.use(VueMasonry);

export default {
  name: "Home",
  components: {
    Card,
    Input,
    Button,
    Avatar,
    PageTitle,
    SocialCard
  },
  props: [],
  data() {
    return {
      email: "",
      password: "",
      formFields: {
        emails: {
          value: [],
          valid: true,
          errortext: ""
        },
        email: {
          value: "",
          valid: true,
          errortext: ""
        },
        content: {
          value: null,
          valid: true,
          errortext: "",
        },
        upload: {
          value: null,
          valid: true,
          errortext: ""
        },
        name: {
          value: "",
          valid: true,
          errortext: ""
        }
      },
      mediaUrl: null,
      mediaType: "none",
      uploadPercentage: 0,
      hasTries: 0,
      isSent: false,
      isProcessing: false,
      wall: [],
      dummies: 10,
      wallStart: 0,
      wallAmount: 10,
      wallShouldLoad: true,
    };
  },
  computed: {
    hasMedia: function() {
      return this.mediaUrl ? true : false;
    },
    isUploading: function() {
      return this.uploadPercentage > 0;
    },
    teamName: function() {
      if (this.formFields.email.value && this.formFields.email.valid) {
        const mail = this.formFields.email.value;
        const name = mail.substring(mail.lastIndexOf("@") + 1).split(".")[0];
        const upper = name.charAt(0).toUpperCase() + name.slice(1);
        return upper;
      } else {
        return "";
      }
    },
    formValid: function() {
      return (
        this.formFields.email.valid &&
        this.formFields.emails.valid &&
        this.formFields.content.valid &&
        this.formFields.upload.valid &&
        this.formFields.name.valid
      );
    }
  },
  methods: {
    validateInput(field, input) {
      //emails
      var inputvalue = input.value;

      if (field == "emails") {
        if (inputvalue.length === 0) {
          input.valid = false;
          input.errortext = this.$i18n.t("form.receivers.error.empty");
        } else if (inputvalue.length > 10) {
          input.valid = false;
          input.errortext = this.$i18n.t("form.receivers.error.maximum");
        } else {
          input.valid = true;
          input.errortext = "";
        }

        if (inputvalue.includes(this.formFields.email.value)) {
          this.formFields.email.valid = false;
          this.formFields.email.errortext = this.$i18n.t(
            "form.email.error.listed"
          );
        } else {
          this.formFields.email.valid = true;
          this.formFields.email.errortext = "";
        }
      } else if (field == "email") {
        if (inputvalue === "") {
          input.valid = false;
          input.errortext = this.$i18n.t("form.email.error.empty");
        } else if (!this.validEmail(inputvalue)) {
          input.valid = false;
          input.errortext = this.$i18n.t("form.email.error.invalid");
        } else if (
          inputvalue.includes("gmail") ||
          inputvalue.includes("hotmail") ||
          inputvalue.includes("ziggo") ||
          inputvalue.includes("outlook")
        ) {
          input.valid = false;
          input.errortext = this.$i18n.t("form.email.error.company ");
        } else if (this.formFields.emails.value.includes(inputvalue)) {
          input.valid = false;
          input.errortext = this.$i18n.t("form.email.error.listed");
        } else {
          input.valid = true;
          input.errortext = "";
        }
      } else if (field == "content") {
          if (inputvalue === "") {
            input.valid = false;
            input.errortext = this.$i18n.t("form.post.error");
          } else {
            input.valid = true;
            input.errortext = "";
          }
      } else if (field == "name") {
        if (inputvalue === "") {
          input.valid = false;
          input.errortext = this.$i18n.t("form.name.error");
        } else {
          input.valid = true;
          input.errortext = "";
        }
      } else if (field == "upload") {
        let formData = new FormData();
        formData.append("upload", input.value.files[0]);

        const headers = {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${process.env.VUE_APP_API_TOKEN}`
        };

        axios
          .post(`${process.env.VUE_APP_API_HOST}/upload/uploads`, formData, {
            headers,
            onUploadProgress: function(progressEvent) {
              this.uploadPercentage = parseInt(
                Math.round((progressEvent.loaded * 100) / progressEvent.total)
              );
            }.bind(this)
          })
          .then(res => {
            this.mediaType = "image";
            this.mediaUrl = res.data.data.upload._links.data.href;
          });
      }
    },
    schedule: function(e) {
      e.preventDefault();
      let valid = true;

      for (let field in this.formFields) {
        let inputField = this.formFields[field];
        let value = inputField.value;
        if (Array.isArray(value)) {
          if (value.length === 0) {
            inputField.valid = false;
            valid = false;
          }
        } else if (value === "") {
          inputField.valid = false;
          valid = false;
        }
      }
      if (!valid) {
        alert("Not all fields are filled in.");
      } else {
        this.isProcessing = true;

        const payload = {
          creator: this.formFields.email.value,
          team: this.teamName,
          name: this.formFields.name.value,
          message: {
            text: this.formFields.content.value,
            mediaUrl: this.mediaUrl,
            type: this.mediaType
          },
          members: this.formFields.emails.value,
          language: this.$i18n.locale
        };

        localStorage.members = this.formFields.emails.value;

        axios
          .post(`${process.env.VUE_APP_API_HOST}/trial`, payload)
          .then(res => {
            this.isSent = true;
            this.isProcessing = false;
          })
          .catch(error => {
            this.isProcessing = false;

            this.hasTries
              ? alert(this.$i18n.t("form.api.error.multiple"))
              : alert(this.$i18n.t("form.api.error.first"));

            this.hasTries = true;
          });
      }
    },
    handleScroll(event) {
      this.checkScroll();
    },
    checkScroll: function() {
      if (window.scrollY > 70) {
        document.getElementById("composer-wrap")
          ? document.getElementById("composer-wrap").classList.add("fixed")
          : null;
      } else {
        document.getElementById("composer-wrap")
          ? document.getElementById("composer-wrap").classList.remove("fixed")
          : null;
      }
    },
    validEmail: function(email) {
      var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(email);
    },
    handleResponse(response, putBefore) {
      const wallData = convert.xml2json(response.data, { compact: true });
      const json = JSON.parse(wallData).rss.channel.item;

      if (json) {
        if (json.length) {
          let resultArray = [];

          json.forEach(res => {
            if (
              this.wall.filter(w => w.guid._text === res.guid._text).length ===
              0
            ) {
              resultArray.push(res);
            }
          });

          if (putBefore) {
            this.wall = resultArray.concat(this.wall);
          } else {
            this.wall = this.wall.concat(resultArray);
          }
        } else {
          const shouldPush =
            this.wall.filter(w => w.guid._text === json.guid._text).length ===
            0;

          if (shouldPush) {
            if (putBefore) {
              this.wall = [json].concat(this.wall);
            } else {
              this.wall.push(json);
            }
          }
        }
      } else {
        this.wallShouldLoad = false;
      }
    },
    getNewItems() {
      const url = `${
        process.env.VUE_APP_API_HOST
      }/public-wall?start=0&amount=5`;

      axios
        .get(url)
        .then(res => {
          this.handleResponse(res, true);
        })
        .then(() => {
          setTimeout(() => {
            this.getNewItems();
          }, 10000);
        });
    },
    getWallItems() {
      if (this.wallShouldLoad) {
        const url = `${process.env.VUE_APP_API_HOST}/public-wall?start=${
          this.wallStart
        }&amount=${this.wallAmount}`;
        this.wallStart += this.wallAmount;

        axios.get(url).then(res => {
          this.handleResponse(res, false);
          this.dummies = 0;
        });
      }
    },
    visibilityChanged(isVisible, entry) {
      if (isVisible) {
        this.getWallItems();
      }
    },
    navigateToPremium() {
      window.location.href = "https://apostleconnect.com/";
    },
    navigateToLogin() {
      window.location.href = "https://app.apostleconnect.com/";
    },
    setLanguage(language) {
      this.language = language;
      this.$i18n.locale = language;
    },
  },
  created() {
    window.addEventListener("scroll", this.handleScroll);
    this.checkScroll();
    setTimeout(() => {
      this.getNewItems();
    }, 10000);

    if (localStorage.members) {
      this.formFields.emails.value = localStorage.members.split(",");
    }
  },
  destroyed() {
    window.removeEventListener("scroll", this.handleScroll);
  },
  mounted() {
    this.getWallItems();
  }
};
</script>

<style src="./Home.scss" scoped lang="scss"></style>
